define('Responsive/controllers/ScrollViewController',['require','exports','module','./ViewController','../util/dom','../vendor','../util/extend','../delegates/ScrollViewDelegate'],function(require,exports,module){
    var ViewController = require( './ViewController' ),
        ReDom = require( '../util/dom' ),
        ReVendor = require( '../vendor' ),
        ReExtend = require( '../util/extend' );

    var ScrollViewDelegate = require( '../delegates/ScrollViewDelegate' );
    // Add private variables here
    var Superclass,
        doc = document,
        defaultScrollOpts={
            containerClass : "ScrollViewWrapper",
            vertical    : true,
            horizontal  : false,
            useGPU      : !!ReVendor.has3d,
            bounce      : false,
            momentum    : true,
            autoHideScrollbars : ReVendor.isMac,
            scrollbars  : true
        };

    // Constructor
    function ScrollViewController(){
        // Call super constructor
        Superclass.constructor.call(this);
        this.waitForScroll=false;
        this.uiDelegate = new ScrollViewDelegate();
    }

    ScrollViewController.setScrollOpts=function(opts){
        return ReExtend(defaultScrollOpts,opts);
    };
    ScrollViewController.getScrollOpts=function(){
        return ReExtend({},defaultScrollOpts);  
    }

    // Prototype Inheritence
    ViewController.spawn(ScrollViewController).define({ 
        loadView : function() {
            Superclass.loadView.call(this);
            this.control=false;
            this.canScroll=this.canScroll===undefined ? true : this.canScroll;
            this.setScrollOpts();
            this.uiDelegate.resetControl(this);
            this.childWrapper = doc.createElement("div");
            this.view.appendChild(this.childWrapper);
            this.setClassName(this.view,"ScrollViewController");
        },
        
        enableScroll    : function(){
            this.canScroll=true;
            this.setScroll(this.scroll);
        },
        
        disableScroll    : function(){
            this.canScroll=false;
            this.uiDelegate.resetControl();
        },
        
        setScrollOpts : function(opts){
            this.uiDelegate.config(ReExtend(ScrollViewController.getScrollOpts(),opts));
        },
        
        on : function(evt,handler){
            this.uiDelegate.on(evt,handler);
        },
        
        off : function(evt,handler){
            this.uiDelegate.off(evt,handler);
        },

        getScrollOpts : function(){
            return this.uiDelegate.getConfig();
        },

        setScroll   : function(scroll){
            var newscroll=scroll||this.scroll;
            this.uiDelegate.snapshot();
            if(newscroll){
                this.waitForScroll=false;
                if(this.scroll!==newscroll){
                    this.uiDelegate.resetControl();
                }
                this.scroll=newscroll;
                // this.offsetView = this.scroll;
                if(this.canScroll){
                    this.checkHeight();
                }
                this.uiDelegate.refreshControl();
            }
        },

        checkResized     : function(){
            Superclass.checkResized.call(this);
            this.uiDelegate.refreshControl(this);
        },


        setAvailableHeight        : function(){
            var curHeight=this.availableHeight,
                offsetView;
            Superclass.setAvailableHeight.call(this,"ScrollViewController");

            if(this.rootView){
                    // I'm a rootView controller;
                offsetView = this;
            } else {
                offsetView = this.parentViewController;
            }

            if(this.view && this.canScroll && !this.waitForScroll){
                this.uiDelegate.setScrollHeight(this.availableHeight,this.view,this.scroll,offsetView.view,offsetView.offsetView);
            }
        },
                
        viewDidAppear   : function(){
          var that=this;
            Superclass.viewDidAppear.call(this);

            if(!this.waitForScroll){
                this.setScroll(this.scroll||this.view);
            }
            setTimeout(function(){
                that.uiDelegate.refreshControl(that.scroll);
            },500);
        },
        
        viewWillDisappear   : function(){
            this.uiDelegate.snapshot();
            this.uiDelegate.resetControl();
            Superclass.viewWillDisappear.call(this);
        },

        viewDidDisappear    : function(){
            Superclass.viewDidDisappear.call(this);
            this.uiDelegate.resetControl();
            this.scroll=null;
        },

        viewDidUnload   : function(){
            this.childWrapper=null;
            this.view=null;
            Superclass.viewDidUnload.call(this);
        }
    });
    Superclass=ScrollViewController.superclass;
    // Add view controller class to Responsive library
    return ScrollViewController;

});
